import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { Message } from '@patsnap/tahiti-core/common/message';
import type VueI18n from 'vue-i18n';
import {
    CheckSensitiveWordDTO,
} from '@/services/ai-translation/service/ai-translation.repository.interface';
import { I18nService } from '@analytics/shared/services/i18n.interface';


export const CheckSensitiveWordService = Symbol('CheckSensitiveWordService');

export interface CheckSensitiveWordService {
    checkSensitiveWord: (word: string) => Promise<string>;
}

@injectable()
export class CheckSensitiveWordServiceImpl implements CheckSensitiveWordService {
    constructor(
        @inject(Message)
        private _message: Message,
        @inject(I18nService)
        private _i18n: VueI18n,
        @inject(CheckSensitiveWordDTO)
        private _checkSensitiveWordDTO: CheckSensitiveWordDTO,
    ) {
    }

    public async checkSensitiveWord(text: string) {
        if (!text) return Promise.resolve('');
        const res = await this._checkSensitiveWordDTO.fetch(text);
        if (res) {
            this._message.closeAll();
            this._message.error({
                message: this._i18n.t('aiTranslation.sensitiveTip') as string,
                showClose: true,
            });
        }
        return res;
    }

}
